var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.config
    ? _c(
        "div",
        { key: _setup.elementKey, staticClass: "calendar-section" },
        [
          _c(_setup.CalendarColorField, {
            attrs: {
              title: "Selected Date Font Color",
              value: _setup.config.dayColorHighlight,
              disabled: _setup.disabled,
            },
            on: {
              input: function ($event) {
                return _setup.update({ dayColorHighlight: $event })
              },
            },
          }),
          _vm._v(" "),
          _c(_setup.CalendarFieldTitle, [
            _vm._v(
              _vm._s(
                _setup.isCustomMarker ? "Marker Image" : "Marker Image & Color"
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "marker-row rounded",
              class: { disabled: _setup.disabled },
              attrs: { "data-testid": "calendar-marker-row" },
              on: { click: _setup.openModal },
            },
            [
              _c("span", { staticClass: "marker-thumbnail" }, [
                _setup.markerThumbnail
                  ? _c("img", {
                      attrs: {
                        src: _setup.markerThumbnail,
                        alt: _setup.presetMarker?.label ?? "Custom marker",
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "flex-fill text-truncate" }, [
                _vm._v(
                  _vm._s(
                    _setup.isCustomMarker
                      ? "Custom"
                      : _setup.presetMarker?.label
                  )
                ),
              ]),
              _vm._v(" "),
              _c(_setup.CButton, {
                attrs: {
                  size: "icon",
                  icon: ["far", "arrows-rotate"],
                  disabled: _setup.disabled,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.openModal.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _setup.isCustomMarker
                ? _c(_setup.CButton, {
                    attrs: {
                      size: "icon",
                      icon: ["far", "trash-can"],
                      disabled: _setup.disabled,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.removeCustomMarker.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _setup.isCustomMarker && _setup.config.customMarkerPath
            ? _c(_setup.CInput, {
                attrs: {
                  value:
                    _setup.config.customMarkerScale ??
                    _setup.DEFAULT_CUSTOM_MARKER_SCALE,
                  type: "decimal",
                  step: ".1",
                  min: 0.1,
                  label: "Marker Scale",
                  "data-testid": "calendar-marker-scale",
                  disabled: _setup.disabled,
                },
                on: { input: _setup.onMarkerScaleChange },
              })
            : _vm._e(),
          _vm._v(" "),
          !_setup.isCustomMarker
            ? [
                _c(_setup.CalendarColorField, {
                  attrs: {
                    value: _setup.config.markColor,
                    disabled: _setup.disabled,
                  },
                  on: { input: _setup.onMarkerColorChange },
                }),
                _vm._v(" "),
                _c(_setup.CCheckbox, {
                  attrs: {
                    value: _setup.config.markFill,
                    label: "Fill Marker",
                    disabled: _setup.disabled,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.update({ markFill: $event })
                    },
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _setup.modalOpen
            ? _c(_setup.MaskSelectorModal, {
                attrs: {
                  type: _setup.MARKER_MASK_TYPE,
                  presets: _setup.markerPresets,
                  title: "Select or Upload a Marker",
                  accept: ".svg",
                  "max-kb-size": _setup.CUSTOM_MARKER_MAX_KB,
                },
                on: {
                  select: _setup.onMarkerSelected,
                  cancel: function ($event) {
                    _setup.modalOpen = false
                  },
                  error: function ($event) {
                    return _setup.toaster.error($event)
                  },
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }